import MenuInfo from 'data/menu';
import { createAuditLog } from './activityAxios';
import { getPrivateIP } from 'data/data';

export async function writeAuditLog({
    actionType,
    targetType,
    targetId,
    targetName,
    
    apiUrl,
    requestMethod,
    summary = "",
    payload = "",
}) {
    try {
        const privateIp = await getPrivateIP();
        const pathname = window.location.pathname;
        const menu = MenuInfo.ROOT.findDeepest(pathname);
        if (!menu || menu.children?.length > 0) {
            return;
        }

        let payloadString = null;

        if (payload instanceof FormData) {
            payloadString = JSON.stringify(
                Object.fromEntries(payload.entries())
            );
        } else if (payload && typeof payload === "object") {
            payloadString = JSON.stringify(payload);
        } else {
            payloadString = payload;
        }

        console.log({
            menuId: menu.id,
            menuName: menu.name, // i18n key
            pageUrl: pathname,
            privateIpAddress : privateIp,

            actionType,
            targetType,
            targetId,
            targetName,

            apiUrl,
            requestMethod,
            summary,
            payload : payloadString
        });

        await createAuditLog({
            menuId: menu.id,
            menuName: menu.name, // i18n key
            pageUrl: pathname,
            privateIpAddress : privateIp,

            actionType,
            targetType,
            targetId,
            targetName,

            apiUrl,
            requestMethod,
            summary,
            payload : payloadString
        });
    } catch (e) {
        console.error(e);
    }
}